import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchSearch, resetSearchQuery } from 'store/search/actions';
import Search from 'components/Search';
import withKeepingLastFocus from 'components/HOCs/withKeepingLastFocus';

const mapState = createStructuredSelector({
  isLoading: () => false, //selectIsLoading,
  results: () => [], // selectSearchResult,
  initialQuery: () => '', //selectSearchInitialQuery,
});

const mapDispatch = {
  fetchSearch,
  resetSearchQuery,
};

export default compose(connect(mapState, mapDispatch), withKeepingLastFocus)(Search);
